module.exports = __webpack_public_path__ + "static/media/2022c.e9cf3428.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2022c.png
// module id = 805
// module chunks = 0